import * as Constants from '../../Pages/Constants';
import { withStyles } from '@material-ui/core';
import { useCallback } from 'react';
import React, { useState, useEffect, useRef } from "react";
import { FormattedMessage } from 'react-intl';
import { Row, Col, Card } from 'antd'
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Range, getTrackBackground } from 'react-range';
import Switch from "react-switch";
import PostDataController from '../../Controller/PostDataController.js';
import ScheduleSelector from 'react-schedule-selector'
import BreathingManager from           './BreathingManager.js';

const NivForm = (props) => {

  const { classes } = props;
  const [step, setStep] = useState(0);
  const [message, setMessage] = useState("");
//  const [results, setResults] = useState([{label:"respiratory_rate", value:"0"}, {label:"respiratory_rate_datetime", value:new Date().toISOString().slice(0, -8)}, {label:"respiratory_leak", value:"0"}, {label:"respiratory_leak_datetime", value:new Date().toISOString().slice(0, -8)}, {label:"oxygen_flow_rate", value:"0"}, {label:"oxygen_flow_rate_datetime", value:new Date().toISOString().slice(0, -8)}]);
  const [results, setResults] = useState([{label:"respiratory_rate", value:null}, {label:"respiratory_leak", value:null}]);
  const [scheduleVni, setScheduleVni] = useState(props.scheduleVni)
  const [respiratoryRateTime, setRespiratoryRateTime] = useState(props.respiratoryRateTime)
  const [leakageTime, setLeakageTime] = useState(props.leakageTime)
  const timeOptions = ["min", "h"]
  const granularity = 1
  const numberOfDays = Math.round((props.end_date - props.start_date) / (1000 * 60 * 60 * 24))

  const getResult = (label) => {
    let index = results.findIndex((r) => r.label === label)
    return(results[index])
  }

  const sendingForm = async () => {
    let formattedScheduleVni = []
    formattedScheduleVni = BreathingManager.formatScheduleData(scheduleVni, granularity)
    results.push({label:"niv_schedule", value:formattedScheduleVni})

    //Filling Respiratory rate
    let index_respiratory_rate = results.findIndex((r) => r.label === "respiratory_rate")
    if (index_respiratory_rate !== -1 && results[index_respiratory_rate].value !== null) {
      let new_value_respiratory_rate = Number(results[index_respiratory_rate].value)
      if (respiratoryRateTime === "h") {
        new_value_respiratory_rate /= 60
      }
      results[index_respiratory_rate].value = String(new_value_respiratory_rate)
    }


    //Filling Respiratory leak
    let index_leakage = results.findIndex((r) => r.label === "respiratory_leak")
    if (index_leakage !== -1 && results[index_leakage].value !== null) {
      let new_value_leakage = Number(results[index_leakage].value)
      if (leakageTime === "h") {
        new_value_leakage /= 60
      }
      results[index_leakage].value = String(new_value_leakage)
    }

    // Send data in backend & update display
    //Format VNI schedule with start / end dates
    let current_Date = new Date()                                                                           // Get current date 
    await PostDataController.post_bundle_observation(current_Date, results, "breathing", props.id_patient); // Send data in backend   

    let convertedData2 = BreathingManager.formatBreathingDataForUpdate(results)                            // convert data for backend
    await props.update(current_Date, convertedData2, props.BannerDisplayedAlerts);                          // update display

    props.cancelPopup();
  }

  const changeResultValue = (e) => {
    let new_results = [...results]
    let index = new_results.findIndex((r) => r.label === e.target.name)
    new_results[index] = {label: e.target.name, value: e.target.value}
    setResults(new_results)
  }

  const changeScheduleVni = (e) => {
    setScheduleVni(e)
  }

  const changeSelect = (e) => {
    switch (e.target.id) {
      case "respiratory_rate_time":
        setRespiratoryRateTime(e.target.value)
        break
      case "respiratory_leak_time":
        setLeakageTime(e.target.value)
        break
    }
  }

  const renderInputOneSelect = (message_id, defaultMessage, input_name, select_value, select_change) => {
    return (
      <Row style={{width:"100%", color: "black", textAlign: 'left'}}>
        <Col style={{width:"5%"}}>
        </Col>
        <Col style={{width:"50%"}}>
          <FormattedMessage id={message_id} defaultMessage={defaultMessage}/>
        </Col>
        {
          /*
          //will be used for datetime data registering
          <Col style={{width:"25%"}}>
            <input style={{width:"100%"}} type="datetime-local" name={input_name+"_datetime"} value={getResult(input_name+"_datetime").value} onChange={(e) => changeResultValue(e)}/><br/>
          </Col>
          */
        }
        <Col style={{width:"15%"}}>
          <input style={{width:"100%"}} type="number" name={input_name} min={0} step={1} precision={1} value={getResult(input_name).value} onChange={(e) => changeResultValue(e)}/><br/>
        </Col>
        <Col style={{width:"15%", textAlign: 'right'}}>
        {input_name === "respiratory_rate" ?
          "Cycle/"
          :
          "L/"
        }
        </Col>
        <Col style={{width:"15%", textAlign: 'right'}}>
          <select style={{width:"100%"}} value={select_value.value} onChange={(e) => select_change(e)} id={input_name + "_time"} name={input_name + "_time"}>
            {
              timeOptions.map((opt,index)=> {
                return (<option value={opt} key={index}>{opt}</option>);
              })
            }
          </select>
        </Col>
      </Row>
    )
  }

  const generatePageVNI = () => {
    return (
      <div>
        <Row style={{ fontWeight: "bold", fontSize:"1.5em", color: "black", display: 'block', textAlign: 'center'}}>
          <FormattedMessage id="breathing.form.title" defaultMessage="Machine monitoring"/>
        </Row>
        <ScheduleSelector
          selection={scheduleVni}
          startDate={props.start_date}
          numDays={numberOfDays}
          minTime={0}
          maxTime={24}
          hourlyChunks={granularity}
          onChange={changeScheduleVni}
          dateFormat="DD/MM"
          timeFormat="HH\h"
        />
        <b style={{color: "black"}}>{message}</b>
        <br/>
        {renderInputOneSelect("breathing.form.niv.four", "Respiratory leak", "respiratory_leak", leakageTime, changeSelect)}
        {renderInputOneSelect("breathing.form.niv.three", "Respiratory rate", "respiratory_rate", respiratoryRateTime, changeSelect)}
      </div>
    )
  }

  let generalFormWidth = "75%"
  if (props.screenSize.width < 800) {
    generalFormWidth = "100%"
  }
  return (
    <div className={classes.popup_background}>
      <div style={{ width:{generalFormWidth}, height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form" style={{ borderRadius: "5px"}}>
          {generatePageVNI()}
          <br/>
          <button onClick={props.cancelPopup} className="btn btn-danger">
            <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
          </button>
          <button onClick={sendingForm} className="btn btn-success">
            <FormattedMessage id="button.submit" defaultMessage="Submit" />
          </button>
        </div>
      </div>
    </div>
  );

}
export default withStyles(Constants.styles)(NivForm);
